import script from "./MobileMenuFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileMenuFooter.vue?vue&type=script&setup=true&lang=ts"

import "./MobileMenuFooter.vue?vue&type=style&index=0&id=43a372f2&lang=scss"

const __exports__ = script;

export default __exports__